import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20250502-Rate-Sheet.pdf";
const date = "02.05.2025";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>
    <p>
      <strong>Changes to our mortgage products</strong>
    </p>
    <p>With effect from Friday 2 May 2025, we will be making the following changes to our range:</p>
    <p>
      <strong>Summary of changes</strong>
    </p>
    <p>
      <strong>UK Residential Existing Customer Switching Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>3 Year Fixed Fee Saver at 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>3 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>10 Year Fixed Fee Saver at 60%, 70%, 75% and 80% LTV have decreased</li>
      <li>10 Year Fixed Standard at 60%, 70%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Residential Existing Customer Borrowing More Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>3 Year Fixed Fee Saver at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>3 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>10 Year Fixed Fee Saver at 60%, 70%, 75% and 80% LTV have decreased</li>
      <li>10 Year Fixed Standard at 60%, 70%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Residential First Time Buyer Range</strong>
    </p>
    <p>&nbsp;</p>
    <ul>
      <li>2 Year Fixed Fee Saver at 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Fixed High Value Mortgages at 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed High Value Mortgages at 70% and 75% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential First Time Buyer Energy Efficient Home Range (A &amp; B EPC Rated Properties)</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Home Mover Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Fixed High Value Mortgages at 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed High Value Mortgages at 70% and 75% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Home Mover Energy Efficient Home Range (A &amp; B EPC Rated Properties)</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 70%, 75%, 80%, 85%, 90% and 95% LTV have decreased</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>5 Year Fixed Standard at 70%, 75%, 80%, 85% and 90% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Remortgage Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>2 Year Fixed High Value Mortgages at 60%, 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>5 Year Fixed High Value Mortgages at 60%, 70% and 75% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Remortgage Cashback Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Remortgage Energy Efficient Home Range (A &amp; B EPC Rated Properties)</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>2 Year Tracker Standard at 90% LTV has decreased</li>
    </ul>
    <p>
      <strong>UK Residential Remortgage Cashback Energy Efficient Home Range (A &amp; B EPC Rated Properties)</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70%, 75% and 90% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80% and 85% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Buy to Let Purchase Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard &pound;3999 at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Standard &pound;3999 at 60%, 65% and 75% LTV has decreased</li>
      <li>2 Year Fixed Premier Exclusive Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Fee Saver at 60%, 65%,75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Buy to Let Existing Customer Switching Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Standard at 60%, 65% and 75% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Buy to Let Existing Customer Borrowing More Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
    </ul>
    <p>
      <strong>UK Buy to Let Remortgage Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Standard &pound;3999 at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Standard &pound;3999 at 60%, 65% and 75% LTV has decreased</li>
      <li>2 Year Fixed Premier Exclusive Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Fee Saver at 60%, 65%, 75% and 80% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive Standard at 60%, 65%, 75% and 80% LTV have decreased</li>
    </ul>
    <p>
      <strong>International Residential Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70% and 75% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 70% and 75% LTV have decreased</li>
      <li>3 Year Fixed Fee Saver at 70% and 75% LTV have decreased</li>
      <li>3 Year Fixed Standard at 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have decreased</li>
      <li>10 Year Fixed Fee Saver at 60%, 70% and 75% LTV have decreased</li>
      <li>10 Year Fixed Standard at 60%, 70% and 75% LTV have decreased</li>
      <li>2 Year Fixed Premier Exclusive at 60%, 70% and 75% LTV have decreased</li>
      <li>5 Year Fixed Premier Exclusive at 60%, 70% and 75% LTV have decreased</li>
    </ul>
    <p>
      <strong>International Buy to Let Range</strong>
    </p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have decreased</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have decreased</li>
    </ul>
    <p>There are no other changes to our interest rates.</p>
    <p>An updated mortgage rate sheet will be published on Friday 2 May 2025 to reflect these changes.</p>
  </NewsArticleLayout>
);

export default Article;
